import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { Spacer } from "@Components/Space"
import React from "react"
import { StyleSheet, View } from "react-native"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"
import { ContainerStackScreen } from "@Components/ContainerStackScreen"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { CustomScrollview } from "@Components/CustomScrollView/CustomScrollView"
import { useNavigation, useRoute } from "@react-navigation/native"
import SvgEntretientSuiviIcon from "@Components/CustomIcon/SvgEntretientSuiviIcon"
import { confirmAction, freeslotDateFormat, fullName, localDateFormat } from "@Utils/utils"
import moment from "moment"
import { useAppointmentHooks } from "../../../Hooks/useAppointmentHooks"
import { Button } from "@Components/CustomButton/Button"
import { isNull } from "lodash"

export const AppointmentDetails = ({}) => {
    const route = useRoute()
    const appointmentData = route?.params?.data
    const doctorInfos = appointmentData?.professionals?.[0]?.attendeeUser
    const doctor = fullName(doctorInfos?.firstName, doctorInfos?.lastName)
    const { handleDeleteAppointment, deleting } = useAppointmentHooks()
    const navigation = useNavigation()

    const handlePressBtn = () =>
        confirmAction(
            "Annulation d'un rendez-vous",
            "Voulez-vous vraiment annuler ce rendez-vous ?",
            "Non",
            "Annuler le rdv",
            () => handleDeleteAppointment({ appointmentId: appointmentData?.id })
        )

    const joinRoom = () => navigation.navigate("AppointmentVisioContent", { eventData: appointmentData })

    const isVisio = appointmentData?.isInSitu === false || appointmentData?.consultationType?.code === "VISIO"
    const hasUUID = !isNull(appointmentData?.visioconference?.uniqid)

    console.log({ appointmentData })

    return (
        <ContainerStackScreen style={{ backgroundColor: baseColors.white, paddingHorizontal: 0 }}>
            <CustomScrollview paddingTop={0}>
                <View style={{ backgroundColor: baseColors.black }}>
                    <Spacer height={20} />

                    <View
                        style={{
                            ...styles.row,
                            backgroundColor: baseColors.black,
                            padding: 20,
                            paddingBottom: 50,
                            justifyContent: "space-between"
                        }}
                    >
                        <BreeSerifText textAlign={"center"} fontSize={22} color={baseColors.white}>
                            Détails du rendez-vous
                        </BreeSerifText>

                        <SvgEntretientSuiviIcon height={40} width={40} />
                    </View>

                    <View style={styles.overlay}>
                        <Spacer />

                        <View style={styles.row}>
                            <OpenSansText
                                defaultFontFamily={baseFontFamily.OpenSansBold}
                                fontSize={16}
                                color={baseColors.green.primary}
                            >
                                Date :
                            </OpenSansText>

                            <OpenSansText
                                style={{ marginLeft: 10 }}
                                defaultFontFamily={baseFontFamily.OpenSansSemiBold}
                                fontSize={14}
                                color={baseColors.black}
                            >
                                {moment(appointmentData?.startDate, freeslotDateFormat).format(
                                    localDateFormat + " à HH:mm"
                                )}
                            </OpenSansText>
                        </View>

                        <Spacer />

                        <View style={styles.row}>
                            <OpenSansText
                                defaultFontFamily={baseFontFamily.OpenSansBold}
                                fontSize={16}
                                color={baseColors.green.primary}
                            >
                                Type de consultation :
                            </OpenSansText>

                            <OpenSansText
                                style={{ marginLeft: 10 }}
                                defaultFontFamily={baseFontFamily.OpenSansSemiBold}
                                fontSize={14}
                                color={baseColors.black}
                            >
                                {appointmentData?.consultationType?.code}
                            </OpenSansText>
                        </View>

                        <Spacer />

                        <View style={styles.row}>
                            <OpenSansText
                                defaultFontFamily={baseFontFamily.OpenSansBold}
                                fontSize={16}
                                color={baseColors.green.primary}
                            >
                                Soignant :
                            </OpenSansText>

                            <OpenSansText
                                style={{ marginLeft: 10 }}
                                defaultFontFamily={baseFontFamily.OpenSansSemiBold}
                                fontSize={14}
                                color={baseColors.black}
                            >
                                {doctor ?? "Non renseigne"}
                            </OpenSansText>
                        </View>

                        <Spacer />
                    </View>
                </View>
            </CustomScrollview>

            {isVisio && hasUUID && (
                <Button
                    text="Rejoindre la visio"
                    onPress={joinRoom}
                    backgroundColor={baseColors.green.primary}
                    labelColor="white"
                    disabled={deleting}
                    loading={deleting}
                />
            )}

            <Button
                text="Annuler le rendez-vous"
                onPress={handlePressBtn}
                backgroundColor={baseColors.orange.primary}
                labelColor="white"
                disabled={deleting}
                loading={deleting}
            />
        </ContainerStackScreen>
    )
}

const styles = StyleSheet.create({
    overlay: {
        marginTop: -15,
        width: "100%",
        borderTopLeftRadius: 15,
        borderTopRightRadius: 15,
        backgroundColor: "white",
        padding: 20
    },
    row: {
        width: "100%",
        flexDirection: "row",
        alignItems: "center"
    }
})
